// Event tracking utilities for analytics
import { trackEvent, trackInteraction, trackFormSubmission as trackFormSubmit, trackScrollDepth as trackScroll } from './tagManager';

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  trackFormSubmit(formName, success ? 'success' : 'failure');
};

// Track button clicks
export const trackButtonClick = (buttonName, section) => {
  trackInteraction('button', 'click', `${section} - ${buttonName}`);
};

// Track service selection
export const trackServiceSelection = (serviceName) => {
  trackEvent('service_selection', {
    service_name: serviceName,
    category: 'Services'
  });
};

// Track portfolio item views
export const trackPortfolioView = (projectName) => {
  trackEvent('portfolio_view', {
    project_name: projectName,
    category: 'Portfolio'
  });
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  trackScroll(depth, document.title);
};

// Track time on page
export const trackTimeOnPage = (seconds) => {
  trackEvent('time_on_page', {
    duration_seconds: seconds,
    category: 'Engagement',
    page_title: document.title,
    page_path: window.location.pathname
  });
};

// Track outbound link clicks
export const trackOutboundLink = (url) => {
  trackInteraction('link', 'click', url);
  
  // Add additional data for outbound links
  trackEvent('outbound_link_click', {
    destination_url: url,
    category: 'Outbound'
  });
};

// Track file downloads
export const trackDownload = (fileName) => {
  trackEvent('file_download', {
    file_name: fileName,
    category: 'Downloads'
  });
};

// Track social media interactions
export const trackSocialInteraction = (network, action) => {
  trackEvent('social_interaction', {
    social_network: network,
    social_action: action,
    category: 'Social'
  });
};

// Track search queries
export const trackSearch = (query) => {
  trackEvent('site_search', {
    search_term: query,
    category: 'Search'
  });
};

// Track video interactions
export const trackVideoInteraction = (videoName, action) => {
  trackEvent('video_interaction', {
    video_name: videoName,
    video_action: action,
    category: 'Video'
  });
};

// Track page load performance
export const trackPagePerformance = () => {
  if (window.performance && window.performance.timing) {
    const timing = window.performance.timing;
    const pageLoadTime = timing.loadEventEnd - timing.navigationStart;
    const domLoadTime = timing.domComplete - timing.domLoading;
    
    trackEvent('page_performance', {
      page_load_time_ms: pageLoadTime,
      dom_load_time_ms: domLoadTime,
      category: 'Performance'
    });
  }
};